import { InsightDrawer } from "./InsightDrawer";
import { Insight } from "../InsightsTable/InsightsTable";
import { KPI } from "../InsightsTable/__generated__/InsightsTableQuery.graphql";
import { CurrencyType } from "../TopPerformingAds/__generated__/TopPerformingAdsQuery.graphql";
import { LabelLiftData } from "./useSafeLabelLiftQuery";


interface InsightDrawerWithCachedDataProps {
  insight: Insight;
  kpi: KPI | null;
  kpiDisplay: string;
  currencyType: CurrencyType;
  cachedData: LabelLiftData[];
  insightsGraphEnabled: boolean;
  metricInsightGraphEnabled?: boolean;
  onCloseDrawer: () => void;
  onShareInsight?: () => void;
}

export const InsightDrawerWithCachedData = ({
  insight,
  kpi,
  kpiDisplay,
  currencyType,
  cachedData,
  insightsGraphEnabled,
  metricInsightGraphEnabled = false,
  onCloseDrawer,
  onShareInsight
}: InsightDrawerWithCachedDataProps) => {
  return (
    <InsightDrawer
      insight={insight}
      kpi={kpi}
      kpiDisplay={kpiDisplay}
      currencyType={currencyType}
      res={cachedData}
      insightsGraphEnabled={insightsGraphEnabled}
      metricInsightGraphEnabled={metricInsightGraphEnabled}
      onCloseDrawer={onCloseDrawer}
      onShareInsight={onShareInsight}
    />
  );
};
